import {
  sendLoadingMessage,
  sendReadyMessage,
  sendGameLoadedMessage,
  sendResourceReportMessage,
} from '@utils/postMessage';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, ignoreElements, tap } from 'rxjs/operators';

import { app } from '../../app';
import { config } from '../../config';
import { user } from '../../user';

const appReadyEpic = (action$) => action$.pipe(
  ofType(app.start),
  tap(() => {
    sendReadyMessage();
    sendGameLoadedMessage({ gameName: 'lobby' });
  }),
  ignoreElements(),
);

const appLoadingEpic = (action$) => action$.pipe(
  ofType(config.request),
  tap(() => {
    sendLoadingMessage();
  }),
  ignoreElements(),
);

const resourceReportEpic = (action$) => action$.pipe(
  ofType(user.request, config.request, user.set, config.set),
  tap(() => {
    sendResourceReportMessage();
  }),
  ignoreElements(),
  // eslint-disable-next-line no-console
  catchError(console.error),
);

export default combineEpics(appReadyEpic, appLoadingEpic, resourceReportEpic);
